import type { BrandingConfig } from "../../branding/types";
import type { AppBrand } from "./types";

/** An overlay rather than a brand of its own: unset fields fall through to the
    resolved base. The exception is base-brand artwork — a footer, avatar or
    loading mark drawn for Needl has no business appearing under another brand,
    so those are cleared rather than inherited. */
export const applyAppBrandOverlay = (
  base: BrandingConfig,
  demo: AppBrand,
): BrandingConfig => ({
  ...base,
  logo: demo.logo,
  logoOnDark: demo.logo,
  logoFull: demo.logo,
  logoFullOnDark: demo.logo,
  logoFullClassName: "h-9 max-w-[176px]",
  favicon: demo.favicon,
  name: demo.name,
  scAppName: demo.appName,
  disclaimerAppName: demo.appName,
  loginFooterContent: undefined,
  botAvatar: undefined,
  chatLoadingLogo: undefined,
});

export const appBrandDocument = (demo: AppBrand) => ({
  title: demo.tabTitle,
  faviconHref: demo.favicon,
});
